const FALLBACK_WATERMARK =
  '';

/**
 * Resolve the watermark URL from the mount root's `data-watermark-url`
 * (set in bf-preview.liquid / ai-landing.liquid), falling back to the
 * uploaded Shopify Files SVG. Read from whichever root is on the page.
 */
export function getWatermarkUrl(): string {
  if (typeof document === 'undefined') return FALLBACK_WATERMARK;
  const root =
    document.getElementById('bf-preview-root') || document.getElementById('bf-widget-root');
  return root?.dataset.watermarkUrl || FALLBACK_WATERMARK;
}
